import React, { FC, useEffect, useState } from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import {
  RiHeartLine,
  RiSearchLine,
  RiLayoutGridLine,
  RiTeamLine,
  RiUserFollowLine,
  RiMessage3Line,
  RiUserAddLine,
  RiUserHeartLine,
  RiUserStarLine,
} from "react-icons/ri";
import useDashboard from "../../hooks/useDashboard";
import LoadingSpinbox from "../../components/UICore/LoadingSpinbox";

const Dashboard: FC = () => {
  const { metrics, loading, error } = useDashboard();

  if (loading)
    return (
      <div className="py-8">
        <LoadingSpinbox textBelow="Loading dashboard data..." />
      </div>
    );
  if (error) return <div>Error: {error}</div>;
  if (!metrics) return <div>No data available</div>;

  return (
    <div className="flex flex-col w-full max-w-7xl mx-auto px-4">
      <div className="py-8">
        <h1 className="text-4xl font-bold mb-8">Internal Dashboard</h1>

        <div className="grid grid-cols-3 gap-6 mb-12">
          <div className="bg-blue-50 rounded-lg border-2 border-blue-600 p-6">
            <div className="flex items-center gap-2">
              <RiUserAddLine className="text-xl text-gray-800" />
              <h3 className="text-gray-800 text-sm font-medium">New Users</h3>
            </div>
            <p className="text-3xl font-bold mt-2">{metrics.newUsers}</p>
            <p className="text-sm text-gray-500 mt-1">Last 30 days</p>
          </div>

          <div className="bg-pink-50 rounded-lg border-2 border-pink-600 p-6">
            <div className="flex items-center gap-2">
              <RiUserHeartLine className="text-xl text-gray-800" />
              <h3 className="text-gray-800 text-sm font-medium">Matches</h3>
            </div>
            <p className="text-3xl font-bold mt-2">{metrics.matches}</p>
            <p className="text-sm text-gray-500 mt-1">Last 30 days</p>
          </div>

          <div className="bg-purple-50 rounded-lg border-2 border-purple-600 p-6">
            <div className="flex items-center gap-2">
              <RiUserStarLine className="text-xl text-gray-800" />
              <h3 className="text-gray-800 text-sm font-medium">
                Introductions
              </h3>
            </div>
            <p className="text-3xl font-bold mt-2">{metrics.introductions}</p>
            <p className="text-sm text-gray-500 mt-1">Last 30 days</p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-8">
          <h2 className="text-xl font-semibold mb-6">Quick Actions</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            <a
              href="/attractiveness"
              className="p-4 text-center rounded-lg border border-gray-200 hover:bg-gray-50 flex flex-col items-center gap-2"
            >
              <RiHeartLine className="text-xl" />
              Attractiveness
            </a>
            <a
              href="/fit-finder"
              className="p-4 text-center rounded-lg border border-gray-200 hover:bg-gray-50 flex flex-col items-center gap-2"
            >
              <RiSearchLine className="text-xl" />
              Fit Finder
            </a>
            <a
              href="/grid"
              className="p-4 text-center rounded-lg border border-gray-200 hover:bg-gray-50 flex flex-col items-center gap-2"
            >
              <RiLayoutGridLine className="text-xl" />
              Grid
            </a>
            <a
              href="/crm"
              className="p-4 text-center rounded-lg border border-gray-200 hover:bg-gray-50 flex flex-col items-center gap-2"
            >
              <RiTeamLine className="text-xl" />
              CRM
            </a>
            <a
              href="/introductions"
              className="p-4 text-center rounded-lg border border-gray-200 hover:bg-gray-50 flex flex-col items-center gap-2"
            >
              <RiUserFollowLine className="text-xl" />
              Introductions
            </a>
            <a
              href="/sms"
              className="p-4 text-center rounded-lg border border-gray-200 hover:bg-gray-50 flex flex-col items-center gap-2"
            >
              <RiMessage3Line className="text-xl" />
              SMS
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withAuthenticationRequired(Dashboard, {
  returnTo: "/",
  onRedirecting: () => <Dashboard />,
});
